<template>
  <kst-page-edit
    @init="handleInit"
    @submit="handleSubmit"
  >
    <Receive :userData="userData"/>
    <Details
      :userData="userData"
      :userItems="userItems"
      :warehouseOptions="warehouseOptions"
    />
    <Items
      :receiveItems="receiveItems"
      :userData="userData"
      :userItems="userItems"
    />

    <div class="columns">
      <div class="column is-half">
        <Details2
          :userData="userData"
        />
      </div>
      <div class="column">
        <Total :userData="userData"/>
      </div>
    </div>
  </kst-page-edit>
</template>

<script>
import InputPageMixin from "../../../mixins/InputPageMixin.js";
import Model from "../RrcvModel.js";
import Services from "../../../services/Api/ReturnReceiveServices.js";

import Details from "./RrcvE_Details.vue";
import Details2 from "./RrcvE_Details2.vue";
import Receive from "./RrcvE_Receive.vue";
import Items from "./RrcvE_Items.vue";
import Total from "./RrcvE_Total.vue";

export default {
  mixins: [InputPageMixin],
  components: {
    Details,
    Details2,
    Receive,
    Items,
    Total
  },
  data: () => ({
    userData: {},
    userItems: [],
    rtnReceiveData: {},
    receiveItems: [],
    warehouseOptions: {}
  }),
  methods: {
    /*** by page ***/

    handleInit(id, loadEdit) {
      this.resetData();

      const config = Services.getEditData(id);
      loadEdit(config, this.handleInit_Success);
    },
    handleInit_Success(data) {
      this.warehouseOptions = Model.getWarehouseOptions(data.WarehouseList);
      this.rtnReceiveData = data.Details;
      this.receiveItems = data.ReceiveItemsWithReturn;

      this.updateByData();
    },

    handleSubmit(saveData, skipSave) {
      if (Model.Edit.compareData(this.userData, this.userItems,
        this.rtnReceiveData
      )) {
        skipSave(
          { [this.$kst.Enum.Response.ID]: this.userData.ID },
          this.handleSubmit_Success
        );
        return;
      }

      let data = Model.populateData(this.userData, this.userItems);
      const config = Services.putData(data);
      saveData(config, this.handleSubmit_Success);
    },
    handleSubmit_Success() {
      this.disableRouteLeave();
    },

    /*** custom ***/

    resetData() {
      this.userData = Model.createDetails();
      this.userItems = [];
      this.rtnReceiveData = {};
      this.receiveItems = [];
      this.warehouseOptions = {};
    },

    updateByData() {
      // receive items
      Model.Edit.updateReceiveItems(
        this.receiveItems, this.rtnReceiveData.Items
      );

      // return receive
      Model.Edit.setItemsByData(this.userItems, this.rtnReceiveData.Items);
      Model.Edit.setDetailsByData(this.userData, this.rtnReceiveData);
      Model.updateDetails(this.userData, this.userItems);
    }
  }
}
</script>